import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import ProjectService from "../Services/ProjectService";
import OrganizationService from "../Services/OrganizationService";
import UsertoOrganizationService from "../Services/UsertoOrganizationService";
import { useAuth } from "../Services/AuthContext";
import "../CSS/Sidebar.css";

const Sidebar = ({ isSidebarOpen, toggleSidebar, refreshProjects }) => {
  const navigate = useNavigate();

  const { user, loading: authLoading } = useAuth();

  const roles = user?.roles || [];
  const userId = user?.userId || null;

  console.log("User roles in Sidebar:", roles);
  const isSuperAdmin = roles.includes("Super Admin");
  const isOrgAdmin = roles.includes("Organization Admin");

  const [organizations, setOrganizations] = useState([]);
  const [expandedOrgId, setExpandedOrgId] = useState(null);
  const organizationIds = user?.organizationIds || [];
  const projectIds = user?.projectIds || [];

  const [projects, setProjects] = useState([]);
  const [activeProjectId, setActiveProjectId] = useState(null);
  const [loading, setLoading] = useState(false);

  /* org create */
  const [showOrgForm, setShowOrgForm] = useState(false);
  const [orgName, setOrgName] = useState("");
  const [orgError, setOrgError] = useState(null);

  // useEffect(() => {
  //   const loadOrganizations = async () => {
  //     try {
  //       // CASE 1: SUPER ADMIN
  //       if (isSuperAdmin) {
  //         const res = await OrganizationService.getAllOrganizations();
  //         setOrganizations(res.data || []);
  //         return; // IMPORTANT: stop here
  //       }

  //       //CASE 2: OTHER USERS (Org Admin / User)
  //       const uoRes =
  //         await UsertoOrganizationService.getAllUserToOrganization();

  //       const myMappings = uoRes.data.filter(
  //         (item) => String(item.userId) === String(userId),
  //       );

  //       // FIX 2: organization is already inside response
  //       const myOrganizations = myMappings.map((item) => item.organization);

  //       setOrganizations(myOrganizations);
  //     } catch (err) {
  //       console.error("Failed to load organizations", err);
  //     }
  //   };

  //   if (user?.userId) {
  //     loadOrganizations();
  //   }
  // }, [user?.userId, isSuperAdmin]);

  useEffect(() => {
    const loadOrganizations = async () => {
      try {
        //  SUPER ADMIN
        if (isSuperAdmin) {
          const res = await OrganizationService.getAllOrganizations();
          setOrganizations(res.data || []);
          const data = res.data?.data || res.data || [];
          setOrganizations(Array.isArray(data) ? data : []);
          return;
        }

        //  ORG ADMIN / USER
        const orgRequests = organizationIds.map((orgId) =>
          OrganizationService.getOrganizationbyid(orgId),
        );

        const responses = await Promise.all(orgRequests);
        const orgList = responses
          .map((res) => res.data?.data || res.data)
          .filter(Boolean);

        setOrganizations(orgList);
      } catch (err) {
        console.error("Failed to load organizations", err);
      }
    };

    if (user?.userId && (isSuperAdmin || organizationIds.length > 0)) {
      loadOrganizations();
    }
  }, [user?.userId, isSuperAdmin, isOrgAdmin, organizationIds]);

  // useEffect(() => {
  //   if (!expandedOrgId) {
  //     setProjects([]);
  //     return;
  //   }

  //   const loadProjects = async () => {
  //     setLoading(true);

  //     try {
  //       //  SUPER ADMIN → use your existing "get all" if available
  //       if (isSuperAdmin) {
  //         const res = await ProjectService.getallProject(expandedOrgId);
  //         setProjects(res.data || []);
  //         return;
  //       }

  //       //  ORG ADMIN / USER → load projects from JWT
  //       const projectRequests = projectIds.map((projectId) =>
  //         ProjectService.getProjectById(expandedOrgId, projectId)
  //           .then((res) => res.data)
  //           .catch(() => null) // project not in this org → ignore
  //       );

  //       const projectResults = await Promise.all(projectRequests);

  //       const validProjects = projectResults.filter(Boolean);

  //       setProjects(validProjects);
  //     } catch (err) {
  //       console.error("Failed to load projects", err);
  //       setProjects([]);
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  //   loadProjects();
  // }, [expandedOrgId, refreshProjects]);

  useEffect(() => {
    if (!expandedOrgId) {
      setProjects([]);
      return;
    }

    setLoading(true);
    setProjects([]);

    ProjectService.getProjectsByOrganization(expandedOrgId)
      .then((res) => {
        console.log("DEBUG: Raw Project API Response:", res);
        const data = res.data?.data || res.data || [];
        console.log("DEBUG: Extracted project data:", data);

        const normalizedProjects = (Array.isArray(data) ? data : []).map(
          (p) => ({
            ...p,
            id: p.id || p.projectId, // Ensure 'id' exists
          }),
        );

        console.log("DEBUG: Normalized projects:", normalizedProjects);
        setProjects(normalizedProjects);
      })
      .catch((err) => {
        console.error("DEBUG: Failed to load projects:", err);
        setProjects([]);
      })
      .finally(() => setLoading(false));
  }, [expandedOrgId, refreshProjects]);

  const handleCreateOrganization = async () => {
    if (!orgName.trim()) {
      setOrgError("Organization name required");
      return;
    }

    try {
      const res = await OrganizationService.createOrganization({
        organizationName: orgName.trim(),
      });
      setOrganizations((prev) => [...prev, res.data]);
      setOrgName("");
      setShowOrgForm(false);
      setOrgError(null);
    } catch {
      setOrgError("Failed to create organization");
    }
  };

  console.log("Sidebar render - user roles:", roles);
  console.log("Sidebar render - user:", user);

  const canCreateOrganization = isSuperAdmin;
  // const canCreateProject = isSuperAdmin || isOrgAdmin;

  if (authLoading) {
    return null;
  }

  const allowedProjects =
    isSuperAdmin || isOrgAdmin
      ? projects || []
      : (projects || []).filter((project) => {
          const match = (user?.projectIds || []).some(
            (id) => String(id) === String(project.id),
          );
          console.log(
            `Checking project ${project.name} (${project.id}): match=${match}`,
          );
          return match;
        });

  const userName = user?.username || user?.userId || "User";

  const displayRole = roles.length ? roles.join(", ") : "User";

  return (
    <>
      {/* {organizations.length === 0 && (
        <div style={{ padding: "16px", color: "#777" }}>
          No organizations found
        </div>
      )} */}

      <div
        className={`sidebar-overlay ${isSidebarOpen ? "active" : ""}`}
        onClick={toggleSidebar}
      />

      <div className={`sidebar ${isSidebarOpen ? "open" : ""}`}>
        <div className="sidebar-user">
          <div className="sidebar-user-avatar">
            {userName.charAt(0).toUpperCase()}
          </div>

          <div className="sidebar-user-text">
            <div className="sidebar-user-name">{userName}</div>
            <div className="sidebar-user-role">{displayRole}</div>
          </div>
        </div>

        <div className="sidebar-header">
          <h3>API Manager</h3>
          <button className="close-sidebar" onClick={toggleSidebar}>
            &times;
          </button>
        </div>
        {/* ORGANIZATION HEADER WITH + */}
        <div className="sidebar-section-header org-header-row">
          <span>Organization</span>
          {canCreateOrganization && (
            <button
              className="add-org-btn"
              onClick={() => setShowOrgForm((prev) => !prev)}
            >
              +
            </button>
          )}
        </div>

        {/* CREATE ORGANIZATION FORM */}
        {showOrgForm && (
          <div className="org-create-form">
            <input
              type="text"
              placeholder="Organization name"
              value={orgName}
              onChange={(e) => setOrgName(e.target.value)}
            />
            {orgError && <span className="error-text">{orgError}</span>}

            <div className="org-form-actions">
              <button onClick={handleCreateOrganization}>Create</button>
              <button
                className="cancel"
                onClick={() => {
                  setShowOrgForm(false);
                  setOrgName("");
                  setOrgError(null);
                }}
              >
                Cancel
              </button>
            </div>
          </div>
        )}

        {/* ORGANIZATION LIST */}

        {organizations.map((org) => {
          const isExpanded = expandedOrgId === org.organizationId;

          return (
            <div key={org.organizationId} className="org-container">
              {/* ORG ROW (Crop Master style) */}
              <div
                className="org-header"
                onClick={() =>
                  // setExpandedOrgId(isExpanded ? null : org.organizationId)
                  setExpandedOrgId(
                    expandedOrgId === org.organizationId
                      ? null
                      : org.organizationId,
                  )
                }
              >
                <span className="org-title">{org.organizationName}</span>
                <span className={`org-arrow ${isExpanded ? "open" : ""}`}>
                  ▾
                </span>
              </div>

              {/* NESTED PROJECTS */}
              {isExpanded && (
                <>
                  {/* PROJECT LABEL + */}
                  <div className="project-header-row">
                    <span className="project-label">Projects</span>

                    {/* {canCreateProject && ( */}
                    <button
                      className="add-org-btn"
                      onClick={() =>
                        navigate(
                          `/organization/${org.organizationId}/project/new`,
                        )
                      }
                    >
                      +
                    </button>
                    {/* )} */}
                  </div>

                  <ul className="org-projects">
                    {loading ? (
                      <li className="loading-spinner" />
                    ) : allowedProjects.length ? (
                      allowedProjects.map((project) => (
                        <li
                          key={project.id}
                          className={`org-project-item ${
                            activeProjectId === project.id ? "active" : ""
                          }`}
                          onClick={() => {
                            setActiveProjectId(project.id);
                            navigate(
                              `/organization/${org.organizationId}/project/${project.id}`,
                            );
                          }}
                        >
                          <span className="project-arrow">▶</span>
                          {project.name}
                        </li>
                      ))
                    ) : (
                      <li className="no-projects">No projects available</li>
                    )}
                  </ul>
                </>
              )}
            </div>
          );
        })}

        {isSuperAdmin && (
          <div className="sidebar-section-header org-header-row">
            <span>User Management</span>
            <button className="add-org-btn" onClick={() => navigate("/users")}>
              →
            </button>
          </div>
        )}

        {isOrgAdmin && (
          <div className="sidebar-section-header org-header-row">
            <span>User Management</span>
            <button
              className="add-org-btn"
              onClick={() => navigate("/organization-admin")}
            >
              →
            </button>
          </div>
        )}
      </div>
    </>
  );
};

export default Sidebar;
